import { get, post } from "app/apis";
import TransitRoutes from "./TransitRoutes";

const TransitService = {
  getTransitService: async () => {
    const data = await get(TransitRoutes.getTransitService);
    return data;
  },
  deleteTransitService: async (obj) => {
    const data = await post(TransitRoutes.deleteTransitService, obj);
    return data;
  },
};

export default TransitService;
